import React from 'react'
import { useLocation } from "react-router-dom";

import { VEHICLE_IMAGES } from "../../../Utils/Vehicleimg";
import qr from "../../../assets/Qr.png";
import bgImg from "../../../assets/Grid.png"

const { car, truck, auto, bike } = VEHICLE_IMAGES;

const vehicleData = {
  "Two Wheeler": {
    name: "Two Wheeler",
    image: bike,
  },
  "Three Wheeler": {
    name: "Three Wheeler",
    image: auto,
  },
  "Four Wheeler": {
    name: "Four Wheeler",
    image: car,
  },
  "Mini Truck": {
    name: "Mini Truck",
    image: truck,
  },
};

const DownloadApp = () => {
  const location = useLocation();

  const normalizeVehicleName = (vehicle = "") => {
    const value = String(vehicle).trim().toLowerCase();

    if (value.includes("two") || value.includes("2")) {
      return "Two Wheeler";
    }

    if (value.includes("three") || value.includes("3")) {
      return "Three Wheeler";
    }

    if (
      value.includes("four") ||
      value.includes("4") ||
      value.includes("eeco") ||
      value.includes("car")
    ) {
      return "Four Wheeler";
    }

    if (
      value.includes("mini") ||
      value.includes("truck") ||
      value.includes("pickup")
    ) {
      return "Mini Truck";
    }

    return vehicle;
  };

  const selectedVehicle = normalizeVehicleName(
    location.state?.vehicle || sessionStorage.getItem("selectedVehicle") || ""
  );

  const remainingVehicles = Object.entries(vehicleData).filter(
    ([vehicleName]) => vehicleName !== selectedVehicle
  );
 return (
  <>
  <section className="w-full  py-16 px-4"
   style={{
      backgroundImage: `url(${bgImg})`,
    }}>
    
    <div className="mx-auto flex max-w-3xl items-center justify-between rounded-3xl bg-[#f3dfcc] px-8 py-10 shadow-sm">
      
      {/* LEFT CONTENT */}
      <div className="max-w-[320px] text-left">
        <h2 className="text-3xl font-bold leading-tight text-[#2b2b2b]">
          Fast, Simple Deliveries
          <br />
          with Packky
        </h2>

        <p className="mt-5 text-lg leading-relaxed text-[#444]">
          Use the Packky app to book and manage
          your deliveries with ease.
        </p>
      </div>

      {/* RIGHT QR */}
      <div className="flex flex-col items-center">
        <div className="rounded-lg bg-white p-2 shadow-sm">
          <img
            src={qr}
            alt="QR Code"
            className="h-[150px] w-[150px] object-contain"
          />
        </div>

        <p className="mt-4 text-sm font-semibold uppercase tracking-wide text-[#2b2b2b]">
          Scan the QR Code
        </p>
      </div>

    </div>
  </section>
  <section className="w-full bg-white px-4 pb-14"
     style={{
      backgroundImage: `url(${bgImg})`,
    }}>
      <div className="mx-auto max-w-5xl text-center">
        <span className="mb-4 inline-flex rounded-full bg-blue-50 px-5 py-2 text-xs font-semibold uppercase tracking-wide text-blue-700">
          More Options
        </span>

        <h2 className="text-[28px] font-extrabold leading-tight text-[#07142f] md:text-[30px]">
          Other Services to Choose From
        </h2>

        <p className="mx-auto mt-4 max-w-[620px] text-sm leading-6 text-slate-500">
          You selected{" "}
          <span className="font-bold text-blue-700">
            {selectedVehicle || "a vehicle"}
          </span>
          . Here are the other available services.
        </p>

        <div className="mx-auto mt-9 flex max-w-[620px] flex-wrap justify-center gap-5 md:gap-6">
          {remainingVehicles.map(([vehicleName, data]) => (
            <div
              key={vehicleName}
              className="flex h-[185px] w-[165px] flex-col items-center justify-center rounded-[22px] bg-[#eef4ff] px-4 py-5 shadow-sm transition hover:-translate-y-1 hover:shadow-md"
            >
              <div className="mb-5 flex h-[48px] w-[64px] items-center justify-center rounded-2xl bg-white shadow-sm">
                <img
                  src={data.image}
                  alt={data.name}
                  className="h-[38px] w-[48px] object-contain"
                />
              </div>

              <h3 className="mb-8 text-[14px] font-extrabold text-[#07142f]">
                {data.name}
              </h3>

              <button
                type="button"
                className="flex h-[24px] w-[48px] items-center justify-center rounded-full bg-blue-600 text-sm font-bold text-white transition hover:bg-blue-700"
              >
                →
              </button>
            </div>
          ))}
        </div>

        {remainingVehicles.length === 0 && (
          <div className="mx-auto mt-8 max-w-md rounded-2xl bg-[#eef4ff] px-6 py-5 text-center text-sm font-semibold text-slate-500">
            No other vehicles available.
          </div>
        )}
      </div>
    </section>
    </>
);
}

export default DownloadApp
